module.exports = __webpack_public_path__ + "officialStatic/img/gdlgLogo.bedf475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/gdlgLogo.png
// module id = g7OK
// module chunks = 0